export const noop = (..._args: any[]): void => {
  // do nothing.
};
